import { FiEye } from "react-icons/fi";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "../style.scss";

const ITEMS_PER_PAGE = 10;

const ESTADO_ABREVIADO = {
  "GESTIÓN INICIADA": "Iniciada",
  "EN PROCESO": "En proceso",
  "GESTIÓN EN SEGUIMIENTO": "En seguimiento",
  "APROBADO": "Aprobado",
  "RECHAZADO POR FINANCIADOR": "Rechazado",
};


function formatDate(value) {
  if (!value) return "-";
  const date = value.split("T")[0];
  const [y, m, d] = date.split("-");
  return `${d}/${m}/${y}`;
}

function toSentenceCase(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const ListadoDesktop = ({ results, loader, total, offset, limit: ITEMS_PER_PAGE_PROP, tipoPedidoMap = {}, onVerDetalle, onSiguiente, onAnterior }) => {
  const pageSize = ITEMS_PER_PAGE_PROP ?? ITEMS_PER_PAGE;
  const totalPages = Math.ceil(total / pageSize);
  const currentPage = Math.floor(offset / pageSize) + 1;

  const handlePageChange = (_event, newPage) => {
    if (newPage > currentPage && onSiguiente) {
      onSiguiente();
    } else if (newPage < currentPage && onAnterior) {
      onAnterior();
    }
  };

  if (loader) {
    return (
      <div className="text-center" style={{ padding: "30px 0" }}>
        <span className="spinner-grow spinner-grow-sm"></span>
        <span className="spinner-grow spinner-grow-sm"></span>
        <span className="spinner-grow spinner-grow-sm"></span>
      </div>
    );
  }

  return (
    <>
      <div className="separador-table-red-result" id="separator-top-results" />

      <div className="row mt-3">
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-hb" id="table-mis-autorizaciones">
              <thead>
                <tr>
                  <th>Fecha creación</th>
                  <th>Fecha intervención</th>
                  <th>Nombre</th>
                  <th>Estado</th>
                  <th>Especialidad</th>
                  <th style={{ textAlign: "center" }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {results.length > 0 ? (
                  results.map((item, i) => (
                    <tr key={i}>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {formatDate(item.fecha)}
                      </td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {formatDate(item.fechaIntervencion)}
                      </td>
                      <td>{item.nombreUsuario}</td>
                      <td>{ESTADO_ABREVIADO[item.estado?.toUpperCase()] || toSentenceCase(item.estado)}</td>
                      <td>{tipoPedidoMap[item.tipoPedido] ?? item.tipoPedido}</td>
                      <td style={{ textAlign: "center" }}>
                        <FiEye
                          size={20}
                          className="autorizacion-accion-icon"
                          style={{ cursor: "pointer" }}
                          onClick={() => onVerDetalle(item)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center", padding: "20px 0" }}>
                      <p className="section_hb_title" style={{ fontSize: "16px" }}>
                        No se encontraron resultados con esas opciones de búsqueda.
                          <br /> Intente con otros parámetros, o contáctese con nuestro equipo de{" "}
                          <a
                            href="mailto:soportewebhb@hbritanico.com.ar"
                            className="section_hb_title"
                            style={{ fontSize: "16px", textDecoration: "underline" }}
                          >
                            Soporte
                          </a>
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="separador-table-red-result" />

      {total > 0 && results.length > 0 && (
        <div className="row">
          <div className="col-12 d-flex justify-content-center my-3">
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                showFirstButton={totalPages > 2}
                showLastButton={totalPages > 2}
                hidePrevButton={totalPages === 1}
                hideNextButton={totalPages === 1}
                color="primary"
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#E0E0E0",
                    color: "#000",
                    "&:hover": { backgroundColor: "#d5d5d5" },
                  },
                }}
              />
            </Stack>
          </div>
        </div>
      )}
    </>
  );
};

export default ListadoDesktop;
